import * as React from 'react'
import {AppointmentForm} from '@devexpress/dx-react-scheduler-material-ui'
import {KeyboardDateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Close from '@material-ui/icons/Close'
import CalendarToday from '@material-ui/icons/CalendarToday'
import {withStyles} from '@material-ui/core/styles'
import FormInput from '../Inputs/FormInput/FormInput'
import Input from '../Input/Input'
import ApiSearchInput from '../Organisms/APISearchInput'
import {Link, useHistory} from 'react-router-dom'
import {useContext} from 'react'
import {AuthContext} from '../../context/AuthContext'
import CalendarModal from "./CalendarModal";

const containerStyles = theme => ({
    cell: {
        height: '200px'
    },
    container: {
        width: theme.spacing(68),
        padding: 0,
        paddingBottom: theme.spacing(2)
    },
    content: {
        padding: theme.spacing(2),
        paddingTop: 0
    },
    header: {
        overflow: 'hidden',
        paddingTop: theme.spacing(0.5)
    },
    closeButton: {
        float: 'right'
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 2)
    },
    button: {
        marginLeft: theme.spacing(2)
    },
    picker: {
        marginRight: theme.spacing(2),
        '&:last-child': {
            marginRight: 0
        },
        width: '50%'
    },
    wrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1, 0)
    },
    icon: {
        margin: theme.spacing(2, 0),
        marginRight: theme.spacing(2)
    },
    textField: {
        width: '100%'
    }
})


class AppointmentFormContainerBasic extends React.PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            appointmentChanges: {title: this.props.appointmentData.title}
        }

        this.getAppointmentData = () => {
            const {appointmentData} = this.props
            return appointmentData
        }
        this.getAppointmentChanges = () => {
            const {appointmentChanges} = this.state
            return appointmentChanges
        }

        this.changeAppointment = this.changeAppointment.bind(this)
        this.commitAppointment = this.commitAppointment.bind(this)
        this.medCenter = this.medCenter.bind(this)
        this.address = this.address.bind(this)
        this.organization = this.organization.bind(this)
        this.comment = this.comment.bind(this)
        this.verificationCenter = this.verificationCenter.bind(this)
    }

    changeAppointment({field, changes}) {
        const nextChanges = {
            ...this.getAppointmentChanges(),
            [field]: changes
        }
        this.setState({
            appointmentChanges: nextChanges
        })

    }

    disabled() {
        const {appointmentChanges} = this.state
        const {appointmentData} = this.props
        return appointmentChanges.organizationId || appointmentData.organizationId
    }

    address(data) {
        const nextChanges = {
            ...this.getAppointmentChanges(),
            title: data.target.value
        }
        this.setState({
            appointmentChanges: nextChanges
        })
    }

    medCenter(id, name) {
        const nextChanges = {
            ...this.getAppointmentChanges(),
            ['medId']: id,
            ['medCenterName']: name
        }
        this.setState({
            appointmentChanges: nextChanges
        })
    }

    organization(id, name) {
        const nextChanges = {
            ...this.getAppointmentChanges(),
            ['organizationId']: id,
            ['orgName']: name
        }
        this.setState({
            appointmentChanges: nextChanges
        })
    }

    verificationCenter(id, name) {
        const nextChanges = {
            ...this.getAppointmentChanges(),
            ['verificationId']: id,
            ['verificationCenterName']: name
        }

        this.setState({
            appointmentChanges: nextChanges
        })
    }

    comment(e) {
        const nextChanges = {
            ...this.getAppointmentChanges(),
            ['comment']: e.target.value
        }

        this.setState({
            appointmentChanges: nextChanges
        })
    }

    commitAppointment(type) {
        const {commitChanges} = this.props
        const appointment = {
            ...this.getAppointmentData(),
            ...this.getAppointmentChanges()
        }
        if (type === 'deleted') {
            commitChanges({[type]: appointment.id})
        } else if (type === 'changed') {
            commitChanges({[type]: {[appointment.id]: appointment}})
        } else {
            commitChanges({[type]: appointment})
        }
        this.setState({
            appointmentChanges: {}
        })
    }

    render() {
        const {
            classes,
            visible,
            visibleChange,
            appointmentData,
            cancelAppointment,
            target,
            calendarFormConf,
            onHide
        } = this.props
        const {appointmentChanges} = this.state

        const displayAppointmentData = {
            ...appointmentData,
            ...appointmentChanges
        }
        const isNewAppointment = appointmentData.id === undefined
        const applyChanges = isNewAppointment
            ? () => this.commitAppointment('added')
            : () => this.commitAppointment('changed')

        const textEditorProps = field => ({
            variant: 'outlined',
            onChange: ({target: change}) => this.changeAppointment({
                field: [field], changes: change.value
            }),
            value: displayAppointmentData[field] || '',
            // label: field[0].toUpperCase() + field.slice(1),
            className: classes.textField
        })

        const pickerEditorProps = field => ({
            className: classes.picker,
            // keyboard: true,
            ampm: false,
            value: displayAppointmentData[field],
            onChange: date => this.changeAppointment({
                field: [field], changes: date ? date.toDate() : new Date(displayAppointmentData[field])
            }),
            inputVariant: 'outlined',
            format: 'DD/MM/YYYY HH:mm',
            onError: () => null
        })

        const cancelChanges = () => {
            this.setState({
                appointmentChanges: {}
            })
            visibleChange()
            cancelAppointment()
        }

        return (
            <AppointmentForm.Overlay
                visible={visible}
                target={target}
                fullSize
                onHide={onHide}
            >
             <CalendarModal />
            </AppointmentForm.Overlay>
        )
    }
}

var Def = (props) => {
    const history = useHistory()
    const {roleId} = useContext(AuthContext)
    const links = {
        2: {
            verificationCenter: props.verificationId && props.verificationCenterName && `/counterAgents/verificationCenters/${props.verificationId}/${props.verificationCenterName}/all`,
            medCenter: props.verificationId && props.medId && props.medCenterName && `/counterAgents/verificationCenters/${props.verificationId}/${props.verificationCenterName}/medCentres/${props.medId}/${props.medCenterName}/organizations`,
            organization: props.verificationId && props.verificationCenterName && props.organizationId && props.orgName && `${props.medId
                ? `/counterAgents/verificationCenters/${props.verificationId}/${props.verificationCenterName}/medCentres/${props.medId}/${props.medCenterName}/organizations/${props.organizationId}/${props.orgName}/history`
                : `/counterAgents/organizations/${props.organizationId}/${props.verificationId}/${props.orgName}/history`}`
        },
        5: {
            medCenter: props.medId && props.medCenterName && `/counterAgents/MedCenterOrgList/${props.medId}/${props.medCenterName}`,
            organization: props.organizationId && props.orgName && `${props.medId
                ? `/counterAgents/MedCenterOrgList/${props.medId}/${props.medCenterName}/organizations/${props.organizationId}/${props.orgName}`
                : `/counterAgents/allOrgList/orgHistory/${props.organizationId}/${props.orgName}`}`
        }
    }

    const link = links[roleId][props.type]
    const onClick = () => {
        history.push(process.env.REACT_APP_URL_PREFIX + link)
    }

    return (
        <div className={'inputWrapper'}>
            {props.children}
            {
                link && <div onClick={onClick} className='linkTo'>
                    <i className='fas fa-arrow-right'/>

                </div>
            }

            <style jsx={true}>{`
              .inputWrapper {
                position: relative;
              }

              .inputWrapper .fas {
                color: cornflowerblue;
              }

              .linkTo {
                width: 20px;
                height: 20px;
                position: absolute;
                right: 10px;
                top: 42px;
                cursor: pointer;
              }
            `}</style>
        </div>
    )
}
const AppointmentFormContainer = withStyles(containerStyles,
    {name: 'AppointmentFormContainer'}
)(AppointmentFormContainerBasic)
export default AppointmentFormContainer